<script>
  import formatDate from '@utils/format-date'
  import {
    eventRegistrationDateRange,
    eventLocationTitle,
    eventLocationContent,
    eventIsDealerOnly, eventSessionTimeTitle, eventOnlineStatusItem
  } from "@utils/zerone-event";
  import { eventTagStatusItem, eventSessionBigButtonStatusItem } from "@utils/zerone-event-status";
  import ListBrand from '@components/List/Brand'
  import ListContact from '@components/List/Contact'
  import ListInfo from '@components/List/Info'
  import { conditionList } from "@utils/is-condition";

  export default {
    components: {
      ListBrand,
      ListContact,
      ListInfo
    },
    props: {
      type: {
        type: String,
        default: 'event',
        validator(value) {
          return [
            'solution',
            'news',
            'event',
            'live',
            'video',
            'case'
          ].includes(value)
        },
      },
      brandLink: {
        type: Array,
        default: () => [],
      },
      pageType: {
        type: String,
        default: '',
      },
      info: {
        type: Object,
        default: () => {
        },
      },
      eventItem: {
        type: Object,
        default: () => {
          return {
            "title": "IxDTW 互動設計年會 2021（實體單天統一）",
            "alias": "alias",
            "seriesNum": "seriesNum",
            "state": 1,
            "type": "physical",
            "dateType": "single",
            "chargeType": "impartial",
            "dateTimeRange": "2021-10-03(六) (08:00~22:00)",
            "registrationType": "partial",
            "registrationStartDate": "2021-08-26 07:59:59",
            "registrationEndDate": "2021-10-02 23:59:59",
            "hasAbsentLimit": 0,
            "absentLimit": 1,
            "canApply": 1,
            "basePrice": 0,
            "salePrice": 0,
            "link": "https://youtu.be/acefhx",
            "bannerImage": "banner.png",
            "slideshow": [
              {
                "path": "slideshow1.png",
                "default": 1
              },
              {
                "path": "slideshow2.png",
                "default": 0
              }
            ],
            "introtext": "設計下一個十年 - 多元與躍進",
            "description": "IxDTW 互動設計年會是 2021 年台灣主要的互動設計與使用者體驗設計的論壇。將於台北舉行，我們即將邀請 25 ~30 位來自國內外產官學界的設計專家及知名講者，分享他們的思維與經驗，以及在設計產品中所遇到的挑戰，讓會眾拓展跨職能的視野。\n\n今年，以「多元與躍進」作為大會主軸，帶領會眾共同思考下一個十年會朝那些趨勢前進，而多元文化是如何影響我們的生活及設計方式，形成新的意義。先行者們，持續躍進及挑戰的過程，將有助我們理解產業的變動，設計師將其價值轉化為設計行動，結合在地優勢面向全世界。",
            "locationName": "張榮發國際會議中心",
            "city": "臺北市",
            "district": "中正區",
            "address": "中山南路11號11樓",
            "zipcode": "101",
            "lat": 25.1234567,
            "lng": 121.02564,
            "canRegisterGroup": 7,
            "requireCoupon": 0,
            "phoneCode": "02",
            "phone": "25316628",
            "needReview": 1,
            "params": [],
            "meals": [
              {
                "id": 3,
                "date": "2021-10-03",
                "options": [
                  "葷食餐點",
                  "素食餐點"
                ],
                "params": []
              },
              {
                "id": 4,
                "date": "2021-10-04",
                "options": [
                  "炙燒北海道干貝丼",
                  "炙燒北海道干貝丼",
                  "馬糞海膽散壽司"
                ],
                "params": []
              }
            ],
            "questions": [
              {
                "title": "感興趣的議題",
                "state": 1,
                "type": "select",
                "value": "",
                "required": 1,
                "description": "請選擇感興趣的議題",
                "params": {
                  "options": [
                    "資訊安全",
                    "虛擬化",
                    "AI大數據"
                  ]
                }
              }
            ],
            "files": [
              {
                "uuid": "F2110Wv8",
                "categoryTitle": "課程檔案",
                "name": "abcdef",
                "description": null,
                "size": "Bytes",
                "publishUp": null,
                "downloadLink": "http://zerone.test/api/file/download/F2110Wv8"
              }
            ],
            "sponsors": [
              {
                "title": "Microsoft",
                "logo": "microsoft.png",
                "link": "https://microsoft.com",
                "description": null
              },
              {
                "title": "Google",
                "logo": "google.png",
                "link": "https://google.com",
                "description": null
              }
            ],
            "brands": [
              {
                "title": "BlcakBerry",
                "alias": "blcakberry",
                "logo": null,
                "contact": [
                  {
                    "name": "王小明",
                    "gender": "先生",
                    "countryCode": "02",
                    "phone": "22221234",
                    "extension": "1111"
                  },
                  {
                    "name": "林小花",
                    "gender": "先生",
                    "countryCode": "02",
                    "phone": "22225566",
                    "extension": "2222"
                  }
                ]
              },
              {
                "title": "VMware",
                "alias": "vmware",
                "logo": null,
                "contact": []
              }
            ],
            "sessions": [
              {
                "date": "2021-10-03",
                "sessions": [
                  {
                    "uuid": "08724314-8b0d-4b8b-bc97-aaf5870b4725",
                    "title": "年會開幕",
                    "startTime": "09:30",
                    "endTime": "09:45",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 0,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "開幕式",
                    "description": "開幕式",
                    "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "6f0fbac6-ea7d-4c9d-b46d-5f8840c1d826",
                    "title": "Making Digital Tangible: The Battle Against the Pixel Empire",
                    "startTime": "09:45",
                    "endTime": "10:55",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 1,
                    "linkOpeningTime": null,
                    "introtext": "數位資訊實體化：一場與像素帝國抗衡的戰役",
                    "description": "時下人機互動的主流研究大多關注實用層面－使用者需求、實際的應用系統，與易用性評估。Tangible Bits 和 Radical Atoms 則是願景驅動的研究，並以藝術取向執行。現今社會一項技術可能一年後就過時了，一個應用系統可能十年後就遭取代。但我們相信，一個真正的願景，能持續發揮影響超過百年。\n\nTangible Bits 的研究目的是實現打造人、數位資訊，與實體環境之間無接縫的介面（Seamless Interfaces），為數位資訊與運算提供實體介面，讓人們可以直接操控位元（bits），也能感知其存在，無論是在前景或背景意識之下（foreground and background of our consciousness）。我們的目標是發明新的設計媒介，不但能適用於科學分析，也應用在藝術表達。Tangible Bits 的研究理念除了利用即時感知與數位回饋帶來的運算呈現外，也充分利用人類豐富的感官能力，與人們ㄧ生與實體世界互動的多樣技能。",
                    "locationName": "張榮發國際會議中心（1101, 1102, 1103）",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "91312205-2007-4800-82fe-625f520c2ff0",
                    "title": "休息交流時間",
                    "startTime": "10:50",
                    "endTime": "11:10",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 0,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "",
                    "description": "",
                    "locationName": "11樓休息區",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "6bffa1c5-a89f-4468-a386-c7b448d6b2c6",
                    "title": "漸進式的改革與創新 - 後疫情時代的設計體驗轉型",
                    "startTime": "11:10",
                    "endTime": "11:50",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "",
                    "description": "產品會隨著人們的生活一起演進，歷史悠久的產品，會發展出深根蒂固的使用習慣，企業內部也有完整的流程與堅實企業文化。然而，習慣與框架有時會成為設計師推進創新的門檻。 Lydia將透過幾個Yahoo奇摩在台灣與Verizon Media在歐洲線的產品開發實例，分享這幾年如何以體驗式設計帶領團隊走進使用者的生活，並且將同理心應用在同事和決策者身上，進而打破既有設計規範、跨國文化，讓體驗文化在組織中發酵，漸進式的改革並創造與時俱進的產品在不同市場中。\n\n我們都期待改革是快速與有效的，但很多時候使用者多年的使用體驗已經定型，Lydia 帶領的 Verizon Media 設計團隊從前期策略規劃、使用者體驗訪談到設計開發與上線後監測優化都有一套完整流程，並帶動合作部門推進創新維度與執行。本次將分享在改革的腳步中，如何加快企業內部的接受度、開發與溝通的速度，並透過設計管理，讓這樣的成功案例可以跨國推進、建立 SOP ; 更重要的是，聚沙成塔，如何有規劃與節奏的讓使用者漸進式轉移，擁抱新的體驗設計，並因應不同市場的快速變化，Lydia也將分享幾個後疫情時代，產品快速調整的實際案例。",
                    "locationName": "1101",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "ebe86034-7fda-464b-bebe-081f35d9703a",
                    "title": "設計作為一種推測與思想實驗",
                    "startTime": "11:10",
                    "endTime": "11:50",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "",
                    "description": "「我們的現實世界被無垠的可能世界所包圍。」\n\nLubomír Doležel, Heterocosmica: Fiction and Possible Worlds, 1999\n2005年從英國皇家藝術學院（Royal College of Art）設計互動系（Design Interactions）開始慢慢萌芽的推測設計（Speculative Design）思維，經過十幾年之後，近年來在西方世界的設計、藝術文化領域，引起了廣大的影響與辯論，而很多專家也認為推測設計是「推測未來」的重要方法之一，而在東方世界，這股氛圍也緩緩升起中。\n\n「設計」如何作為一種推測、如何作為一種思想實驗？本次講座的講者宮保睿，試著帶領你從推測設計的發源起點、思維方式、現在狀況、可能未來、創作與教學實踐來解析各種面向，試著讓我們透過推測設計思維去思考著當面對未知未來時，「這個世界可能會變成什麼樣子？」這個重要的提問。",
                    "locationName": "1102",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "ae14e984-b8a3-4c44-abd9-1ea32ee37583",
                    "title": "春池循環設計的各種實踐與未來",
                    "startTime": "11:10",
                    "endTime": "11:50",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "",
                    "description": "在氣候變遷與溫室效應影響著我們的生活，循環經濟與循環設計變成一個重要未來課題。 「我們過去的需求都是消耗，但我們想塑造的未來是，把未來的需求都成為新的創造。」春池玻璃未來將繼續以循環玻璃為載體，希望影響更多產業走向循環經濟。\n\n春池玻璃，目前跨足於工業原料、科技建材、文化藝術與觀光工廠。本業為專業回收玻璃與再處理之企業，總公司在台灣新竹，並擁有三家相關企業。目前每年回收並處理超過 10 萬噸的春池玻璃，目前為全台最具規模之廢棄玻璃回收業者。其企業理念為永續經營，綠色創新。在 2015 更獲得根留台灣，展望全球之「金根獎」之殊榮。蔡總統英文更在 2016 年 9 月親自參訪春池玻璃觀光工廠，並給予極高評價，稱春池玻璃為台灣「循環經濟」之典範。更在 2017 年獲得 British Chamber of Commerce 之 Better Business Award 社會企業首獎。更在 2018 年獲得總統創新獎與艾森豪獎金學人殊榮",
                    "locationName": "1103",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  }
                ]
              },
              {
                "date": "2021-10-04",
                "sessions": [
                  {
                    "uuid": "bc2a41d9-25f0-4960-a7e3-ca9f5cfbf47f",
                    "title": "混合實境 - 設計領域的新疆土?",
                    "startTime": "09:30",
                    "endTime": "10:40",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 1,
                    "linkOpeningTime": null,
                    "introtext": "混合實境 - 設計領域的新疆土?",
                    "description": "2021年的今天，在微軟出了兩代HoloLens以及臉書也出了兩代 Oculus Quest，穿戴式的顯示技術已逐漸形成一個不可逆的趨勢。五十年前那個笨重的實驗室原型，也開始變小變薄變輕變行動，而輸入裝置從六軸控制器的間接互動，演進成使用雙手與立體圖像進行直接互動。混合實境不再是實驗室與孵化器中的名詞，而逐漸邁入主流產品的軌道。當設計領域開始面對如何設計混合實境這個新議題時，過往用於視窗系統與行動裝置的設計經驗與準則，能否轉移至混合實境的設計?抑或是必須開始探索技術所帶來新的限制與可能性，才能更進一步演化出一套新的設計典範?",
                    "locationName": "1101, 1102, 1103",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "3c5fa5e9-9925-4204-8ece-d4ca86b259b6",
                    "title": "休息交流時間",
                    "startTime": "10:40",
                    "endTime": "11:00",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 0,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "",
                    "description": "",
                    "locationName": "11樓休息區",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "710a7038-f7ec-4491-a783-7c2caebee25e",
                    "title": "我如何進入遊戲UX，而你也可以！",
                    "startTime": "11:00",
                    "endTime": "11:40",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "How I Got into Games UX, and How You Can Too!",
                    "description": "對於有興趣進一步了解遊戲產業，尤其是渴望了解 UX 在遊戲開發中所扮演角色的人們，這正是為你準備的演講！Alan 將以他在遊戲產業廿多年獲得的個人經驗和教訓，說明整合的使用者體驗如何為玩家打造出引人入勝的體驗！\n\n這場演講的終極目標，是希望參加者了解遊戲產業中 UX 可能的發展機會，以及如何在這個令人興奮的領域發展職業生涯。\n\n你是玩家嗎？ 你熱愛使用者體驗嗎？ 如果是的話，這個演講就是為你而存在。",
                    "locationName": "1101",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "58757869-8d90-4755-827f-73751fd25ec7",
                    "title": "用設計翻轉百年老店",
                    "startTime": "11:00",
                    "endTime": "11:40",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "Flip the image of the historic store with design",
                    "description": "2017林務局推出飲食之森月曆，公部門出現不同以往的月曆風格，以全手繪的方式，吸引大眾的目光；2018里山動物、2019木作之森、2010生命之森，連續四年，林務局製作的月曆詢問度破表，網路上討論的熱潮也居高不下還造成搶購熱潮，不僅國內民眾開始注意到林務局的政策和業務，就連外國媒體也因此關注到台灣設計的軟實力，而一手催生這個計畫的，就是現任林務局局長林華慶。\n\n林務局主要有兩大業務，分別是林業和自然保育，相關的政策都和臺灣的自然生態與山林環境息息相關，對民眾的生命福祉影響甚鉅，但以往林務局的存在感卻很低，大多數民眾對林務局的工作感到生疏而遙遠。",
                    "locationName": "1102",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  },
                  {
                    "uuid": "39d82e68-5aee-4331-949d-f16247365f79",
                    "title": "遠距設計協作的心法",
                    "startTime": "11:00",
                    "endTime": "11:40",
                    "isEvent": 0,
                    "slideshow": [
                      {
                        "path": "slideshow1.jpg",
                        "default": 1
                      },
                      {
                        "path": "slideshow2.jpg",
                        "default": 0
                      }
                    ],
                    "canRegistration": 1,
                    "canApply": 0,
                    "linkOpeningTime": null,
                    "introtext": "Designing beyond timezone: The key to effective remote collaboration",
                    "description": "2020 是個意想不到的一年，武漢肺炎迫使多處城市封鎖，公司必須要改變工作型態，遠距協作突然間變成一個全世界的顯學，大家都在嘗試與學習團隊轉移成遠端協作的方法。2021 年疫情仍不見好轉，職員回歸辦公室的政策不明朗，近期許多知名大公司也決定改成「 Remote First 」的合作方式，當有越來越多遠距協作的經驗參考之後，未來遠距工作機會應當會增添不少。對下個世代的設計者來說，或許可以準備好相關技能與思維，考慮這個不一樣的職涯道路！",
                    "locationName": "1103",
                    "city": "臺北市",
                    "district": "中正區",
                    "address": "中山南路11號11樓",
                    "lat": 25.1234567,
                    "lng": 121.02564,
                    "files": [],
                    "link": null
                  }
                ]
              }
            ]
          }
        },
      },
    },
    computed: {
      eventDate() {
        if(!this.info.extrafields) {
          return '即日開始'
        }

        const { register_start: { value: start }, register_end: { value: end } } = this.info.extrafields
        if(start === null && end === null) {
          return '即日開始'
        }
        if(start && end) {
          return `${ formatDate(start, 'yyyy/MM/dd') } 至 ${ formatDate(end, 'yyyy/MM/dd') }`
        }
        if(start === null && end) {
          return `即日起至 ${ formatDate(end, 'yyyy/MM/dd') }`
        }
        if(start && end === null) {
          return `${ formatDate(start, 'yyyy/MM/dd') }開始`
        }

        return '無'
      },
      target() {
        if(!this.info.extrafields) {
          return '無'
        }

        const { dealer_only: { value: isDealer } } = this.info.extrafields
        if(isDealer === '1') {
          return '經銷商限定'
        } else {
          return '一般會員'
        }
      },
      salePrice() {
        const { sale_price: { value: price } } = this.info.extrafields
        return price === null
          ? false
          : price
      },
      isHasContact() {
        return this.brandLink.every(item => item.contact.length === 0)
      },
      tagStatusItem() {
        let result = eventTagStatusItem({
          ...this.eventItem,
        })
        if(result.title === "精彩回放") {
          result.title = "已結束"
        }
        return result
      },
      liveTagStatusItem() {
        return  eventOnlineStatusItem({
          ...this.eventItem
        })
      },
      sessionBigButtonStatusItem() {
        return eventSessionBigButtonStatusItem({
          ...this.eventItem,
        })
      },
      isShowContact() {
        const hasBrand = !!this.eventItem.brands[0];

        return hasBrand
          ? this.eventItem.brands.some(item => {
            return !!item.contact[0]
          })
          : [];
      },
      isDealerOnly() {
        return eventIsDealerOnly({ ...this.eventItem })
      },
      registrationDateRange() {
        return eventRegistrationDateRange({ ...this.eventItem })
      },
      locationContent() {
        return eventLocationContent({
          ...this.eventItem,
          eventType: this.eventItem.type,
        })
      },
      locationTitle() {
        return eventLocationTitle(this.eventItem.type, this.eventItem.categoryTitle)
      },
      sessionTimeTitle() {
        return eventSessionTimeTitle(this.eventItem.type, this.eventItem.categoryTitle)
      },
      infoList() {
        return conditionList([
          // {
          //   title: '<i class="icomoon icon-time mr-2"></i>報名時間',
          //   text: this.registrationDateRange,
          //   condition: () => {
          //     return this.type === 'event'
          //   },
          // },
          {
            title: `<i class="icomoon icon-time mr-2"></i>${ this.sessionTimeTitle }`,
            text: this.eventItem.dateTimeRange,
          },
          {
            title: `<i class="icomoon icon-location mr-2"></i>${ this.locationTitle }`,
            text: this.locationContent,
          },
          {
            type: 'tag',
            title: `<i class="icomoon icon-calender mr-2"></i>${this.eventItem.categoryTitle || '活動'}狀態`,
            text: this.type === 'live' ? this.liveTagStatusItem.title : this.tagStatusItem.title,
            textClass: this.type === 'live' ? this.liveTagStatusItem.class2 : this.tagStatusItem.class,
            condition: () => {
              return this.type === 'event' || this.type === 'live'
            },
          },
          {
            title: `<i class="icomoon icon-lock-icon mr-2"></i>${this.eventItem.categoryTitle || '活動'}對象`,
            text: [
              this.isDealerOnly
                ? `<span class="color-primary">經銷商限定</span>`
                : '',
              this.eventItem.requireCoupon
                ? `<span class="color-primary">指定上課券報名</span>`
                : '',
              this.eventItem.requiredEvent[0]
                ?`<span class="color-primary">需先參加指定課程</span>`
                : '',
            ]
              .filter(item => !!item)
              .join('<br>'),
            condition: () => {
              return this.isDealerOnly || !!this.eventItem.requireCoupon || !!this.eventItem.requiredEvent[0]
            },
          },
        ])
      },
    },
    methods: {
      goBack() {
        this.$router.back(-1)
      },
      onApply() {
        const getIsEventItem = this.eventItem.sessions[0].sessions.filter((item) => {
          return item.isEvent;
        });

        if(getIsEventItem[0]) {
          this.$emit('apply',
            {
              sessionUuids: [getIsEventItem[0].uuid]
            }
          )
        }

        return false
      },
    },
  }
</script>
<template>
  <!-- FIX: 活動課程消息側邊欄 -->
  <div :class="$style.ArticleSideBox">
    <div :class="[$style.ArticleSide, { isStyleLive: type === 'live' , isEvent: type === 'event' }]">
      <template v-if="type === 'news' || type === 'solution' || type === 'video' || type === 'case'">
        <ListBrand :brand-list="brandLink">
          <div v-if="isShowContact" class="col-4 d-lg-none ml-auto text-center align-self-center">
            <el-popover
              placement="bottom"
              trigger="click"
              width="335"
              popper-class="isStyleBase isStyleContact"
            >
              <ListContact
                title=""
                :brand-list="brandLink"
              />
              <el-button slot="reference" class="isStyleContact">業務聯絡 <i class="fas fa-caret-down"></i></el-button>
            </el-popover>
          </div>
        </ListBrand>
        <hr class="mt-md-4 mt-2 mb-0">
      </template>
      <template v-if="$route.params.categoryAlias === 'promotion' && type === 'news'">
        <div class="ArticleSide__info">
          <div class="ArticleSide__info__item">
            <h4 class="ArticleSide__info__item__title">
              <i class="icomoon icon-time ArticleSide__info__icon"></i>
              活動時間
            </h4>
            <p>{{ eventDate }}</p>
          </div>
          <div class="ArticleSide__info__item">
            <h4 class="ArticleSide__info__item__title">
              <i class="icomoon icon-group ArticleSide__info__icon"></i>
              活動對象
            </h4>
            <p>{{ target }}</p>
          </div>
          <template v-if="salePrice">
            <div
              class="ArticleSide__info__item"
            >
              <h4 class="ArticleSide__info__item__title">
                <i class="fal fa-usd-circle ArticleSide__info__icon"></i>
                優惠價格
              </h4>
              <p>NT. {{ salePrice }}</p>
            </div>
          </template>
        </div>
      </template>
      <template v-if="type === 'event' || type === 'live'">
        <ListBrand
          :brand-list="eventItem.brands"
        >
          <div v-if="!!eventItem.contact[0]" class="col-4 d-lg-none ml-auto text-center align-self-center">
            <el-popover
              placement="bottom"
              trigger="click"
              popper-class="isStyleBase isStyleContact"
            >
              <ListContact
                title=""
                type="event"
                :brand-list="eventItem.contact"
              />
              <el-button slot="reference" class="isStyleContact">洽詢專線 <i class="fas fa-caret-down"></i></el-button>
            </el-popover>
          </div>
        </ListBrand>
        <hr class="my-md-4 mt-3">
        <ListInfo
          :info-list="infoList"
        />
        <template v-if="!!eventItem.contact[0]">
          <hr :class="{ 'd-lg-block d-none': type === 'live' }">
          <ListContact
            title="洽詢專線"
            type="event"
            :brand-list="eventItem.contact"
            class="d-lg-block d-none"
          />
        </template>
      </template>
      <div v-if="type !== 'event' && type !== 'live' && !isHasContact" class="d-lg-block d-none">
        <hr class="my-0">
        <div class="ArticleSide__action">
          <ListContact
            title="業務聯絡"
            :brand-list="brandLink"
          />
        </div>
      </div>
    </div>
    <BaseButton
      v-if="type === 'live'"
      class="isStylePrimary w-100 d-lg-block d-none"
      @click="goBack"
    >
      返回
    </BaseButton>
    <template
      v-if="type === 'event'"
    >
      <BaseButton
        v-if="sessionBigButtonStatusItem.display"
        class="w-100 isRadius d-lg-block d-none"
        style="border-radius: 0"
        :class="sessionBigButtonStatusItem.class"
        :disabled="sessionBigButtonStatusItem.disabled"
        @click="onApply"
      >
        {{ sessionBigButtonStatusItem.title }}
      </BaseButton>
    </template>
  </div>
</template>
<style lang="scss" module>
  @mixin transition {
    transition: all 0.3s;
  }

  .ArticleSide {
    position: relative;
    z-index: 1;
    padding: 3.125rem 3.125rem 3rem;
    // margin-top: -290px;
    // margin-bottom: 4.375rem;
    background-color: #FFF;
    box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);

    @include max-lg {
      padding: 1.5rem 0;
      margin-top: 0;
      box-shadow: none;

    }
    :global {
      // .container {
      //   display: flex;
      //   justify-content: flex-end;
      // }
      .ArticleSide {
        // &__link {
        //   display: block;
        //   display: flex;
        //   align-items: center;
        //   justify-content: space-between;
        //   height: auto;
        //   color: $color-gray-5;

        //   &:not(:last-child) {
        //     margin-bottom: 20px;
        //   }

        //   i {
        //     font-size: 1.7rem;

        //     @include transition;
        //   }

        //   &:hover {
        //     color: $color-gray-7;
        //   }
        //   @include max-lg {
        //     display: inline-block;
        //     i {
        //       display: none;
        //     }
        //     &:not(:last-child) {
        //       margin-bottom: 0;
              
        //     }
        //   }
        // }

        // &__link-box {
        //   padding-top: 0.8rem;
        //   padding-bottom: 3.125rem;
        //   @include max-lg {
        //     padding-top: 0;
        //     padding-bottom: 0;
        //   }
        // }

        // &__logo {
        //   height: 80px;

        //   @include max-sm {
        //     height: 65px;
        //   }
        // }

        &__info {
          padding-top: 3.125rem;
          padding-bottom: 0.625rem;
          // border-top: $color-gray-3 1px solid;
          @include max-lg {
            padding-top: 2rem;
          }
          &__item {
            margin-bottom: 2.5rem;
            @include max-md {
              margin-bottom: 1.5rem;
            }
            &__title {
              display: flex;
              align-items: center;
              margin-bottom: 1rem;
              font-size: 1.25rem;
              @include max-md {
                font-size: 1.125rem;
              }
              @include max-sm {
                font-size: 1rem;
              }
            }

            p {
              margin-bottom: 0;
              font-size: 1rem;
              color: $color-gray-6;
              @include max-sm {
                font-size: 0.875rem;
              }
            }

            a {
              color: $color-gray-7;

              &:hover {
                color: $color-primary;
                text-decoration: none;
              }
            }
          }

          i {
            margin-right: 0.6rem;
          }

          &__icon {
            width: 24px;
            margin-right: 0.6rem;
          }
        }

        &__action {
          padding-top: 3.125rem;
          // border-top: $color-gray-3 1px solid;
          // padding-bottom: .625rem;
          &__title {
            margin-bottom: 1.875rem;
            font-size: 1.25rem;
            color: $color-gray-7;
          }

          &__item {
            margin-bottom: 1.5rem;
            font-size: 1rem;
            color: $color-gray-6;

            i {
              width: 1rem;
              text-align: center;
            }

            .fa-phone-volume {
              font-size: 1.1rem;
              transform: rotate(-30deg) translateY(0);
            }

            h5 {
              margin-bottom: 0.8125rem;
              font-size: 1rem;
            }

            ul {
              padding: 0;
              margin: 0;
              list-style: none;
            }

            li {
              padding-bottom: 0.8rem;
            }
          }

          &__icon {
            width: 14px;
            margin-right: 0.3rem;
          }
        }
      }
    }
    &:global {
      &.isStyleLive {
        @include max-md {
          padding-top: 1rem;
        }
      }
    }
  }

  .ArticleSideBox {
    width: 100%;
    margin-left: auto;

    @include max-lg {
      width: 100%;
    }
  }
</style>
